import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomBarChart from '../../data-widgets/CustomBarChart';
import { AggregatedOrganizationStatsData } from '../../../utils/organization-stats-handlers';
import { dateToStringFormat } from '@common/utils/date';
import { DateTime } from 'luxon';
import useDistanceUnitValue from '@common/hooks/useDistanceUnitValue';
import { DistanceValueUnit } from '@common/enums/configuration/units';

const WeeklyCleaningPerformanceChart: React.FC<{
  aggregatedData: AggregatedOrganizationStatsData | null;
  loading?: boolean;
  skipAnimation?: boolean;
  filterWeeks: (week: string) => boolean;
}> = ({ aggregatedData, loading, skipAnimation, filterWeeks }) => {
  const { t } = useTranslation();
  const { label, multiplier } = useDistanceUnitValue(0, DistanceValueUnit.METERS_SQUARED_PER_HOUR);

  return (
    <React.Fragment>
      <CustomBarChart
        title={t('label-weekly-cleaning-performance')}
        loading={loading}
        skipAnimation={skipAnimation}
        xAxis={[
          {
            data: (aggregatedData?.chartData ?? [])
              .filter((data) => filterWeeks(data.week))
              .map((data) => data.week),
            label: t('label-week'),
            scaleType: 'band',
            valueFormatter: (date) => dateToStringFormat(DateTime.fromISO(date), true),
          },
        ]}
        series={[
          {
            data: (aggregatedData?.chartData ?? [])
              .filter((data) => filterWeeks(data.week))
              .map((data) => data.cleaningPerformance * multiplier),
          },
        ]}
        yLabel={label}
      />
    </React.Fragment>
  );
};

export default WeeklyCleaningPerformanceChart;
